import view from './close-button'
export default view
